import React, { Component } from "react";
import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";

import { IonApp } from "@ionic/react";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import Home from "./pages/Home";
import MyTeam from "./pages/MyTeam";
import Playoff from "./pages/Playoff";
import Error404 from "./pages/Error404";
import Upload from "./pages/Upload";
import Login from "./pages/Login";
import { APP_NAME, URLS } from "./urls";
import Player from "./pages/Player";
import Account from "./pages/Account";
import Rules from "./pages/Rules";
import Register from "./pages/Register";
import Firebase from "./firebase";
import User from "./pages/User";
import "./index.css";
import { getCookie, setCookie } from "./cookies";

declare const window, console: any;

class App extends Component {
  state = {
    fb: Firebase.getInstance(),
    redirect: false,
    redirecto: URLS.HOME.url,
  };

  constructor(props: any) {
    super(props);
    window.onerror = async (error, url, line) => {
      console.log("error!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!");
      const recurring = getCookie("page_crash_recurring") !== "";
      const serious = document.getElementById("root").childElementCount === 0;
      await this.state.fb.analyticsEvent("page_crash", {
        error,
        line,
        recurring,
        serious,
        logs: console.logs,
      });
      setCookie("page_crash_recurring", recurring ? "" : true, "10 s");
      if (!recurring && serious) window.location.reload();
    };
  }

  async componentDidMount() {
    console.stdlog = console.log.bind(console);
    console.logs = [];
    console.log = function () {
      console.logs.push(Array.from(arguments));
      console.stdlog.apply(console, arguments);
    };

    console.log(window.location.host);
    if (window.location.host !== URLS.SAFSALEAGE.url && window.location.host !== "localhost:3000") {
      console.log("redirecting...");
      window.location = "https://" + URLS.SAFSALEAGE.url;
    }

    document.addEventListener("authChange", () => {
      setTimeout(() => {
        this.checkURL();
      }, 500);
    });
    document.addEventListener("pageMount", this.checkURL);

    // text-wrap of ion-label
    setInterval(() => {
      // const selectTournamentLabels: any = document.getElementsByClassName("sc-ion-select-popover");
      const selectTournamentLabels: any = document.getElementsByTagName("ion-label");
      for (let i = 0; i < selectTournamentLabels.length; i++) {
        if (selectTournamentLabels[i].tagName === "ION-LABEL") {
          selectTournamentLabels[i].setAttribute("text-wrap", true);
        }
      }
    }, 100);
  }

  checkURL = async () => {
    console.log("check");
    for (const [key, value] of Object.entries(URLS)) {
      if ("/" + window.location.pathname.split("/")[1] === value.url) {
        document.title = APP_NAME + (value.title ? " - " + value.title : "");
        var user = await this.state.fb.getUser();
        var needToVerify = false;
        if (user) {
          const userProvidersIDs = await this.state.fb.userProvidersIDs();
          const phoneProviderID = this.state.fb.phoneProviderID;
          const phoneLinked = userProvidersIDs.includes(phoneProviderID);
          needToVerify = !user.emailVerified && !phoneLinked && !value.forGuests && key !== "ACCOUNT";
          if (needToVerify) {
            if (window.confirm("יש לאמת קודם את החשבון דרך המייל שנשלח. האם לשלוח מייל אימות שוב?")) {
              const res = await this.state.fb.verifyEmail();
              if (res.message) alert(res.message);
            }
          }
        }
        if (user && (!value.forMembers || needToVerify)) {
          const wait =
            Math.abs((new Date() as any) - (new Date(user.metadata.lastSignInTime) as any)) < 1500 ? 1500 : 10;

          setTimeout(() => {
            this.setState({ redirecto: URLS.HOME.url, redirect: true });
            console.log("c u later");
          }, wait);
        }
        if (!user && !value.forGuests) {
          console.log("bye bye");
          setTimeout(() => {
            this.setState({ redirecto: URLS.LOGIN.url, redirect: true });
          }, 10);
        }
      }
    }
  };

  renderRedirect = () => {
    if (this.state.redirect) {
      this.setState({ redirect: false });
      return <Redirect to={this.state.redirecto} />;
    }
  };

  render() {
    return (
      <IonApp>
        <Router>
          {this.renderRedirect()}
          <Switch>
            <Route path="/" component={Home} exact={true} />
            <Route path={URLS.RULES.url} component={Rules} />
            <Route path={URLS.LOGIN.url} component={Login} />
            <Route path={URLS.REGISTER.url} component={Register} />
            <Route path={URLS.ACCOUNT.url} component={Account} />
            <Route path={URLS.MY_TEAM.url} component={MyTeam} />
            <Route path={URLS.PLAYOFF.url} component={Playoff} />
            <Route path={URLS.USER.url + "/:id"} component={User} />
            <Route path={URLS.PLAYER.url + "/:id"} component={Player} />
            {/* <Route path={URLS.REVIEW.url} component={Review} /> */}
            <Route path="/upload" component={Upload} />
            <Route component={Error404} />
          </Switch>
        </Router>
      </IonApp>
    );
  }
}

export default App;
